import { createContext, useContext } from 'react';

const MessagesContext = createContext();

export const MessagesProvider = ({ children }) => {
  // Заглушка для контекста сообщений
  const chats = [];
  const sendProject = () => {};
  const getChatName = () => '';
  const getChatAvatar = () => '';
  const createPersonalChat = () => ({ id: '' });
  const setActiveChat = () => {};

  return (
    <MessagesContext.Provider value={{
      chats,
      sendProject,
      getChatName,
      getChatAvatar,
      createPersonalChat,
      setActiveChat
    }}>
      {children}
    </MessagesContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useMessages = () => {
  const context = useContext(MessagesContext);
  if (!context) {
    throw new Error('useMessages must be used within a MessagesProvider');
  }
  return context;
};